import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddMember } from "../api/members-api";
import { queryClient } from "../api/queryClient";
import { Icon } from "../components/dss/Icon";
import { AdminHeader, Field } from "../components/dss/Primitives";

const AddMember = () => {
  const { mutateAsync: addMember, isLoading } = useAddMember();
  const [name, setName] = useState("");
  const [emoji, setEmoji] = useState("🦊");
  const navigate = useNavigate();

  const onSubmit = async () => {
    if (!name) return;
    await addMember({ name, emoji });
    queryClient.invalidateQueries(["members"]);
    navigate("/admin/members");
  };

  return (
    <div className="mx-auto max-w-md bg-paper pt-safe min-h-app">
      <AdminHeader back="Medlemmer" onBack={() => navigate("/admin/members")} title="Tilføj medlem" />
      <div className="px-7 pt-6 flex flex-col gap-5 pb-8">
        <Field label="Tegn" hint="Et emoji der repræsenterer medlemmet">
          <input
            value={emoji}
            onChange={(e) => setEmoji(e.target.value)}
            maxLength={4}
            className="w-16 bg-card border border-line-soft rounded-lg py-2 px-3 text-xl text-center"
          />
        </Field>
        <Field label="Navn">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full bg-transparent border-b-2 border-ink pb-2 font-display text-xl font-bold uppercase tracking-tight focus:outline-none"
            placeholder="Navn i logen"
          />
        </Field>
        <button
          disabled={!name || isLoading}
          onClick={onSubmit}
          className="w-full py-4 rounded-lg bg-ink text-paper font-display text-sm font-bold tracking-wide uppercase flex items-center justify-center gap-2 disabled:opacity-40"
        >
          <Icon name="user-plus" size={14} />
          Opret plads på signup-listen
        </button>
      </div>
    </div>
  );
};

export default AddMember;
